import PropTypes from 'prop-types';
import React from 'react';
import Spinner from 'components/Spinner/Spinner';
import Link from 'react-router-dom/Link';

PageLoading.propTypes = {
    isLoading: PropTypes.bool,
    timedOut: PropTypes.bool,
    pastDelay: PropTypes.bool,
    error: PropTypes.bool
};

export default function PageLoading(props) {
    if (props.isLoading) {
        if (props.timedOut) {
            return (
                <div className='main-screen'>
                    <div className='container error-boundary'>
                        <h2>Oops! An Error Occurred!</h2>

                        <p>Please try reloading the page or you can go to the <Link to='/'>homepage</Link>.</p>
                    </div>
                </div>
            );
        }
        else if (props.pastDelay) {
            return (
                <div className='main-screen'>
                    <div className='container'>
                        <div className='loading-container text-center'>
                            <Spinner color='#790000' />
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className='main-screen'>
                    <div className='container'/>
                </div>
            );
        }
    }
    else if (props.error) {
        return (
            <div className='main-screen'>
                <div className='container error-boundary'>
                    <h2>Oops! An Error Occurred!</h2>

                    <p>Please try reloading the page or you can go to the <Link to='/'>homepage</Link>.</p>
                </div>
            </div>
        );
    }
    else {
        return (
            <div className='main-screen'>
                <div className='container'/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PageLoading/PageLoading.js